import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contract";
import AbstractSymbolBehaviour from "slotworks/components/matrix/symbol/behaviours/abstract-symbol-behaviour";
import AnimatedSprite from "slotworks/graphics/animation/animated-sprite";
import Rectangle from "slotworks/utils/geom/rectangle";
import Layers from "slotworks/graphics/layers/layers";
import graphicsManager from "slotworks/graphics/graphics-manager";

export default class AnticipateSymbolBehaviour extends AbstractSymbolBehaviour {

    protected masterSymbol: string = "symbol_1_1";

    protected animation: AnimatedSprite;

    private offset: Rectangle;

    private completeResolve: () => void;

    constructor(symbol: SymbolComponent) {
        super(symbol);
    }

    public static() {
        this.cleanUp();
    }

    public anticipate(noLoop: boolean = false): Contract<void> {
        if (this.completeResolve) {
            this.completeResolve();
        }
        this.cleanUp();
        const animName = this.symbol.symbolId + "_antic";
        let animation: AnimatedSprite = graphicsManager.createAnimation(animName);

        if (!animation) {
            return Contract.empty();
        }

        animation.stop();
        animation.visible = false;

        this.symbol.setLayer(Layers.SymbolAnimations);
        Layers.SymbolAnimations.add(animation);

        const masterRect = Layers.MatrixContent.getPosition(this.masterSymbol);
        let animRect = Layers.MatrixContent.getPosition(animName);
        
        if (!animRect) {
            animRect = new Rectangle(0, 0, animation.width, animation.height);
        }

        const offsetX = animRect.x - masterRect.x;
        const offsetY = animRect.y - masterRect.y;
        this.offset = new Rectangle(offsetX, offsetY, animRect.width / masterRect.width, animRect.height / masterRect.height);
        this.animation = animation;
        this.updateLocalTransform();

        animation.visible = true;

        animation.loop = !noLoop;
        animation.gotoAndPlay(0);
        this.symbol.setVisible(false);

        this.animation = animation;

        return new Contract<void>((resolve) => {
            this.completeResolve = () => resolve(null);
        });
    }

    public updateLocalTransform() {
        if (this.animation) {
            const symbolTransform = this.symbol.getTransform();

            const globalPosition = Layers.MatrixContent.localToGlobal(symbolTransform);
            const localPosition = Layers.SymbolAnimations.globalToLocal(globalPosition);

            this.animation.x = localPosition.x;
            this.animation.y = localPosition.y;
            this.animation.width = symbolTransform.width;
            this.animation.height = symbolTransform.height;

            this.animation.x += this.offset.x;
            this.animation.y += this.offset.y;
            this.animation.width *= this.offset.width;
            this.animation.height *= this.offset.height;

            // Adjust for if this is the middle of a stack
            const stackOffset = this.symbol.getStackOffsetY();
            if (stackOffset) {
                this.animation.y -= stackOffset;
            }
        }
    }

    private cleanUp() {
        if (this.animation) {
            this.symbol.setVisible(true);
            this.animation.onComplete = null;
            this.animation.stop();
            Layers.SymbolAnimations.remove(this.animation);
            this.animation = null;
            this.symbol.setLayer(Layers.MatrixContent);
            this.completeResolve = null;
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/components/matrix/symbols/anticipate-symbol-behaviour.ts